var $UPP = $UPP || {};
$UPP = $UPP || {};

(function (upp, document, $UPP, $) {
    'use strict';

    //TODO: Test!!!
    //Shows the loading 'spin'
    upp.directive('loader', ['$rootScope',
        function ($rootScope) {
            var $element,
                loadingTimeout,
                TM = 10000;

            var clearLoadingTimeout = function () {
                if (loadingTimeout) {
                    clearTimeout(loadingTimeout);
                }
            };

            var _showLoading = function () {
                clearLoadingTimeout();

                $element.addClass('page-load');
                loadingTimeout = setTimeout(function () {
                    _hideLoading();
                }, TM);  //If not explicitly closed after 10 seconds.
            };

            var _hideLoading = function () {
                clearLoadingTimeout();
                $element.removeClass('page-load');
            };

            return {
                restrict: 'A',
                controller: function () {
                    $rootScope.showLoading = function () {
                        _showLoading();
                    };
                    $rootScope.hideLoading = function () {
                        _hideLoading();
                    };
                },
                link: function ($scope, element) {
                    $element = element;
                }
            }
        }]);

    //TODO: Test!!!
    //Manages the error message
    upp.directive('errorMessageTpl',
        ['aboutService', 'appi', function (aboutService, appi) {
            return {
                restrict: 'E',
                replace: true,
                priority: 0,
                template: '' +
                    '<div class="global-error-section">' +
                    '   <div id="global-error" class="alert alert-error inline-error without_section-error">' +
                    '       <button type="button" class="close" data-dismiss="alert">&times;</button>' +
                    '       <p class="inline-error-message"><strong>{{\'ERROR\' | i18n}}.</strong> {{error.desc | i18n}} ' +
                    '           <span ng-show="info.contactEnabled">{{ \'CONTACT_CREATOR\' | i18n }}</span></p>' +
                    '   </div>' +
                    '   <ul id="about-tab-contact" class="about-icon-list tab-pane" ng-show="info.contactEnabled">' +
                    '       <li id="about-contact-phone" class="item-box about-icon-item" ng-show="info.phone">' +
                    '           <a class="about-icon" href="tel:{{info.phone}}">' +
                    '               <div class="about-icon-btn icon icon-2x rrss-icon rrss-icon-phone"></div>' +
                    '               <div class="about-icon-link">{{info.phone}}</div>' +
                    '           </a>' +
                    '       </li>' +
                    '       <li id="about-contact-email" class="item-box about-icon-item" ng-show="info.email">' +
                    '           <a class="about-icon" href="mailto:{{info.email}}">' +
                    '               <div class="about-icon-btn icon icon-2x rrss-icon rrss-icon-email"></div>' +
                    '               <div class="about-icon-link">{{info.email}}</div>' +
                    '           </a>' +
                    '       </li>' +
                    '   </ul>' +
                    '</div>',
                link: function ($scope, element) {
                    var $mainContent2hide = $('#content'),
                        $menu2hide;

                    var setMenuElements = function () {
                        $menu2hide = $('#navbar-main-options, #navbar-main-sections');
                    };

                    element.hide();

                    $scope.$watch('error', function (error) {
                        setMenuElements();

                        if (error) {
                            element.show();
                            $mainContent2hide.hide();
                            if (error.full) {
                                if ($menu2hide.length) {
                                    $menu2hide.hide();
                                } else {
                                    //Sometimes, this event fires before the $menu2hide elements are loaded
                                    setTimeout(function () {
                                        setMenuElements();
                                        $menu2hide.hide();
                                    }, 10);
                                }
                            }

                            // If the childupp is expired retrieve the about info and assign it to the scope
                            if (error.expired) {
                                aboutService.getInfo()
                                    .then(function (info) {
                                        $scope.info = info;

                                        appi.ui.hidePageLoadingMsg();
                                    });

                                // Hide content
                                $('.home-business-who').hide();
                            }
                        } else {
                            $menu2hide.show();
                            $mainContent2hide.show();
                            element.hide();
                        }
                    });
                }
            }
        }]);

    //TODO: Test!!!
    //Shows the currency symbol in html
    upp.directive('currency',
        function () {
            return {
                restrict: 'E',
                scope: {
                    currencySymbol: '='
                },
                replace: true,
                link: function ($scope, element) {
                    $scope.$watch('currencySymbol', function (currencySymbol) {
                        if (currencySymbol) {
                            element.replaceWith(currencySymbol);
                        }
                    });
                }
            }
        });

    //TODO: Test!!!
    //Shows a bootstrap's tooltip with the value of the placeholder in fields with the class 'placeholder-tooltip'
    upp.directive('placeholderTooltip', function () {
        return {
            restrict: 'C',
            replace: false,
            link: function ($scope, element) {
                element.tooltip({
                    trigger: 'focus',
                    delay: {show: 500, hide: 0},
                    title: function () {
                        return element.attr('placeholder');
                    }
                });
            }
        }
    });

    //TODO: Test!!!
    //Check if an input value is the same as other, modifying the validity of this field
    upp.directive('sameAs', function () {
        return {
            require: 'ngModel',
            link: function (scope, elm, attrs, ctrl) {
                ctrl.$parsers.unshift(function (viewValue) {
                    if (viewValue === scope[attrs.sameAs]) {
                        ctrl.$setValidity('sameAs', true);
                    } else {
                        ctrl.$setValidity('sameAs', false);
                    }
                    return viewValue;
                });
            }
        };
    });

    //TODO: Test!!!
    //Check if an input value is not greater than max value
    upp.directive('max', function () {
        return {
            require: 'ngModel',
            link: function (scope, elm, attrs, ctrl) {
                ctrl.$parsers.unshift(function (viewValue) {
                    if (parseInt(viewValue) <= parseInt(attrs.max)) {
                        ctrl.$setValidity('max', true);
                    } else {
                        ctrl.$setValidity('max', false);
                    }
                    return viewValue;
                });
            }
        };
    });

    // Intercepts all target attributes in "a" elements and if its value is _blank opens the
    // link in a new window using the cordova system window to imitate a native popup
    upp.directive('target', [function () {
        return {
            restrict: 'A',
            link: function (scope, elem, attrs) {
                if (($UPP.IOS || $UPP.ANDROID)
                    && attrs.target === '_blank'
                    && elem[0].tagName.toUpperCase() === 'A') {
                    elem[0].addEventListener('click', function (e) {
                        e.preventDefault();
                        e.stopPropagation();

                        window.open(elem.attr('href'), '_system');

                        return false;
                    });
                }
            }
        };
    }]);

    upp.directive('select', ['$interpolate', function ($interpolate) {
        return {
            restrict: 'E',
            require: 'ngModel',
            link: function (scope, elem, attrs) {
                var defaultOptionTemplate;
                if (attrs['defaultOption']) {
                    scope.defaultOptionText = attrs['defaultOption'];
                    defaultOptionTemplate = '<option value="" disabled '
                        + (!!attrs['defaultOptionSelected'] ? 'selected' : '')
                        + ' style="display: none;">{{defaultOptionText}}</option>';
                    elem.prepend($interpolate(defaultOptionTemplate)(scope));
                }
            }
        };
    }]);

    upp.directive('bannerTpl', ['$rootScope',
        function ($rootScope) {

            /**
             * @method translateMsg
             * @param msg {Object|String}
             * @returns {String}
             */
            return {
                restrict: 'E',
                template:''+
                    '<div class="banner fcm-push-config-banner">'+
                    '<button class="fcm-push-config-banner-close" type="button" data-ng-show="showCloseInFCMBanner" data-ng-click="close()">×</button>'+
                    '<h4 class="fcm-push-config-banner-text"> {{\'FCMPLUGIN.BANNER\' | i18n}}</h4>'+
                    '</div>',
                replace: true,
                controller: ['$scope',
                    function ($scope) {
                        $scope.close = function(){
                            $rootScope.showFCMBanner = false;
                        }
                    }
                ]
            }
        }]);

})(upp, document, $UPP, window.jQuery);



// WEBPACK FOOTER //
// ./src/app/common/directives/directives.js